// extracted by mini-css-extract-plugin
module.exports = {"notificationRow":"NotificationsRow-module_notificationRow_WrhI5","bubble":"NotificationsRow-module_bubble_1NemG"};